import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class ErrorReportingService {
  log(location: string, step: string, error: unknown, additionalContext: Record<string, unknown> = {}): void {
    if (environment.local) {
      console.error(`Error in ${location} at ${step}`, error, additionalContext);
    }
  }
}
